import {Injectable} from '@angular/core';
import {Request,Headers,Response} from '@angular/http';
import {HttpClient} from '../../../services/http.service';
import{AppConstants} from '../../../app.constants';
import{Observable}from 'rxjs/Rx';
import { LocalStorageService } from 'ng2-webstorage';
import{SectionService}from'../sections/sections.service';
@Injectable()
export class AddUserService{
    public Id: string;
    public Email: any;
    constructor(private SectionService:SectionService,private httpClient: HttpClient, private appConstants: AppConstants, private localStorage:LocalStorageService){
    this.Id = this.localStorage.retrieve('Id');
}
public getSections(): Observable<Response> {
    var url: string = '' + this.appConstants.baseUrl + this.appConstants.sectionalgrade + '/' + this.localStorage.retrieve('SchoolId');
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}
public postUser(userPayload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + this.appConstants.schoolUsers;
    return this.httpClient.Post(url, userPayload)
        .map(this.extractData)
        .catch(this.handleError)
}
public getUserdetailbyId(userId){
    let url: string = '' + this.appConstants.baseUrl + this.appConstants.getSchoolUserById+'?id='+userId+'&schoolid='+this.localStorage.retrieve('SchoolId');
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}


private extractData(res:Response){
    let body = res.json();
    return body;
}

private handleError(error:any){
    let errMsg = (error.message) ? error.message :
    error.status ? `${error.status} - ${error.statusText}` : 'Server error';
let err = JSON.parse(error._body);
return Observable.throw(err);
}
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/manageuser/adduser/adduser.service.ts